import styled from 'styled-components';

export const StyledModalContent = styled.div`
  padding: 2.4rem 4rem 4.6rem;
  text-align: center;

  svg {
    height: 12rem;
    width: auto;
  }
  h1 {
    font-size: 2.4rem;
  }

  span {
    color: ${({ theme }) => theme.colors.success.main};
  }

  ul {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    list-style: none;
    padding-inline-start: 3rem;
    margin-bottom: 1.6rem;
    text-align: left;
    width: fit-content;
    margin: 2.4rem auto;

    li {
      margin-bottom: 1rem;
    }

    svg {
      height: 1.6rem;
      margin-right: 1rem;
      path {
        fill: ${({ theme }) => theme.colors.success.main};
      }
    }
  }
`;
